import { call, put, select, takeEvery } from 'redux-saga/effects';

import { Action, RequestWithIdAndQuery, Types } from '../ducks';
import { EndpointCreator, EntityWithId, IClient, IGetActions } from '../interfaces';
import { getEndpoint } from './endpoint';

/**
  @deprecated - https://github.com/SaleCycle/my-salecycle-com#legacy-code 
*/
export function* get<T>(
  client: IClient<T>,
  endpointCreator: EndpointCreator,
  actions: IGetActions<T>,
  id: string,
  params?: { [key: string]: string },
  queryParams?: { [key: string]: string },
) {
  yield put(actions.startGet(id));

  const endpoint: string = yield select(getEndpoint, endpointCreator, params);
  if (!endpoint) {
    return yield put(actions.failGet(id, "couldn't create endpoint"));
  }

  try {
    const entity: EntityWithId<T> = yield call([client, 'get'], `${endpoint}/${id}`, queryParams);
    return yield put(actions.completeGet(entity));
  } catch (error) {
    return yield put(actions.failGet(id, (error as Error).message));
  }
}

/**
  @deprecated - https://github.com/SaleCycle/my-salecycle-com#legacy-code 
*/
export function newGetSaga<T, S>(
  client: IClient<T>,
  endpointCreator: EndpointCreator,
  actions: IGetActions<T>,
  service: S,
) {
  const isGetRequest = (action: Action<T, S>) => action.type === Types.GET_REQUESTED && action.service === service;

  return function*() {
    yield takeEvery(isGetRequest as any, (action: RequestWithIdAndQuery<S>) =>
      get(client, endpointCreator, actions, action.payload.id, action.payload.params, action.payload.query),
    );
  };
}
